import { createContext, useContext } from 'react';
import Cookies from 'js-cookie';


type MetaPixelContextType = {
    track: (event: string, data?: Record<string, any>) => void;
    getFbp: () => string | null
    getFbc: () => string | null
};

const MetaPixelContext = createContext<MetaPixelContextType>({
    track: () => { },
    getFbp: () => null,
    getFbc: () => null,
});


interface WindowWithPixel {
    fbq?: (...args: any[]) => void
}

export const MetaPixelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const getFbp = (): string | null => {

        return Cookies.get('_fbp') || null;
    }

    const getFbc = (): string | null => {

        return Cookies.get('_fbc') || null;
    }

    const track = (event: string, data?: Record<string, any>) => {
        if (typeof (window as WindowWithPixel).fbq === 'function') {
            (window as WindowWithPixel).fbq!('track', event, data);
        }
    };

    return (
        <MetaPixelContext.Provider value={{ track, getFbc, getFbp }}>
            {children}
        </MetaPixelContext.Provider>
    );
};

export const useMetaPixel = () => useContext(MetaPixelContext);